module.exports = __webpack_public_path__ + "static/media/trim-car-t.b08164a3.png";